export default {
	endpoints: {
		production: 'https://uat.eiascreening.fdclients.co.uk:8443',
	},
};
